export enum MessageDirection {
  INBOUND = "inbound",
  OUTBOUND = "outbound",
}

export enum MessageStatus {
  PENDING = "pending",
  SENT = "sent",
  DELIVERED = "delivered",
  READ = "read",
  FAILED = "failed",
}

export enum MessageType {
  TEXT = "text",
  IMAGE = "image",
  AUDIO = "audio",
  VIDEO = "video",
  FILE = "file",
  MYAUDIO = "myaudio",
  DOCUMENT = "document",
  LOCATION = "location",
  CONTACT = "contact",
  STICKER = "sticker",
  INTERACTIVE = "interactive",
  TEMPLATE = "template",
  REACTION = "reaction",
  SYSTEM = "system",
}

export interface MessageDetailsNotificationDTO {
  id: string
  content: any
  direction: MessageDirection
  message_type: MessageType
  is_ai_message: boolean
  status: MessageStatus
  created_at: Date
  updated_at: Date | null
  metadata?: Record<string, any> | null
  is_forwarded?: boolean
  quoted_message_id?: string | null
  // Author user id (the message sender on the backend). For an internal note
  // this is the authoring attendant, used to gate the author-only edit action.
  sender?: string | null
}

export interface ConversationDetailsNotificationDTO {
  id: string
  contact_name: string | null
  contact_image_url: string | null
  phone_number: string
}

export interface MessageNotificationDTO {
  message: MessageDetailsNotificationDTO
  conversation: ConversationDetailsNotificationDTO
  agent_response?: MessageDetailsNotificationDTO
}
